import type { IPlaybackScheduleRoot, IPlayerRegistrationPayload } from '@lucimark/shared/models/player-registration-payload'
/** Canonical JSON stringify (sorted keys) so that object key order does not affect the result. */
export function canonicalStringify(value: unknown): string {
  if (value === null) {
    return 'null'
  }
  if (typeof value !== 'object') {
    return JSON.stringify(value)
  }
  if (Array.isArray(value)) {
    return `[${value.map(canonicalStringify).join(',')}]`
  }
  const keys = Object.keys(value as object).sort()
  return `{${keys.map(k => `${JSON.stringify(k)}:${canonicalStringify((value as Record<string, unknown>)[k])}`).join(',')}}`
}

/** Simple non-crypto hash for change detection. Returns a short string. */
export function simpleHash(str: string): string {
  let h = 0
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h + str.charCodeAt(i)) | 0
  }
  return (h >>> 0).toString(36)
}

/** Hash of the active playback schedule root (legacy campaign assignment or playlist-only root). */
export function playbackScheduleRegistrationHash(root: IPlaybackScheduleRoot | null): string {
  return simpleHash(canonicalStringify(root))
}

/** @deprecated Use {@link playbackScheduleRegistrationHash} — name retained for call sites. */
export const campaignHash = playbackScheduleRegistrationHash

/** Change detection for distribution list membership + screen title (replaces legacy nested `playerGroup` JSON). */
export function registrationDistributionContextHash(payload: IPlayerRegistrationPayload | null): string {
  if (payload === null) {
    return simpleHash('null')
  }
  return simpleHash(canonicalStringify({
    lists: payload.distributionLists ?? [],
    title: payload.title,
    description: payload.description ?? null
  }))
}
